import { Dictionary } from 'types';

export enum AvailableLanguage {
    En = 'en',
    De = 'de',
    Fr = 'fr',
    Ru = 'ru',
    Nl = 'nl',
    It = 'it',
    Da = 'da'
}

export const platformAvailableLanguages: PlatformAvailableLanguagesMap = {
    [AvailableLanguage.En]: { name: 'English', flag: 'gb' },
    [AvailableLanguage.De]: { name: 'Deutsch', flag: 'de' },
    [AvailableLanguage.Fr]: { name: 'Français', flag: 'fr' },
    [AvailableLanguage.Ru]: { name: 'Pусский', flag: 'ru' },
    [AvailableLanguage.Nl]: { name: 'Nederlands', flag: 'nl' },
    [AvailableLanguage.It]: { name: 'Italiano', flag: 'it' },
    [AvailableLanguage.Da]: { name: 'Dansk', flag: 'dk' }
};

export const platformAvailableLocales: Dictionary<string, AvailableLanguage> = {
    [AvailableLanguage.En]: 'en-US',
    [AvailableLanguage.De]: 'de-DE',
    [AvailableLanguage.Fr]: 'fr-FR',
    [AvailableLanguage.Ru]: 'ru-RU',
    [AvailableLanguage.Nl]: 'nl-NL',
    [AvailableLanguage.It]: 'it-IT',
    [AvailableLanguage.Da]: 'da-DK'
};

export function getRequestedAvailableLanguages(requestedLanguages: AvailableLanguage[]): PlatformAvailableLanguagesMap {
    return requestedLanguages.reduce(
        (languages, requestedLanguage) => ({
            ...languages,
            [requestedLanguage]: platformAvailableLanguages[requestedLanguage]
        }),
        {}
    );
}

type PlatformAvailableLanguagesMap = Dictionary<
    {
        name: string;
        flag: string;
    },
    'language'
>;
